/*! * imagesLoaded PACKAGED v4.1.4 * JavaScript is all like "You images are done yet or what?" * MIT License */
!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return n.indexOf(t)==-1&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return n!=-1&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){i=i.slice(0),t=t||[];for(var n=this._onceEvents&&this._onceEvents[e],o=0;o<i.length;o++){var r=i[o],s=n&&n[r];s&&(this.off(e,r),delete n[r]),r.apply(this,t)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){if(Array.isArray(e))return e;var t="object"==typeof e&&"number"==typeof e.length;return t?d.call(e):[e]}function o(e,t,r){if(!(this instanceof o))return new o(e,t,r);var s=e;return"string"==typeof e&&(s=document.querySelectorAll(e)),s?(this.elements=n(s),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(this.check.bind(this))):void a.error("Bad element for imagesLoaded "+(s||e))}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console,d=Array.prototype.slice;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&u[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var u={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});
// jquery? 
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
// js.cookie
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function g(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function e(l){function C(e,n,o){var t;if("undefined"!=typeof document){if(1<arguments.length){if("number"==typeof(o=g({path:"/"},C.defaults,o)).expires){var r=new Date;r.setMilliseconds(r.getMilliseconds()+864e5*o.expires),o.expires=r}o.expires=o.expires?o.expires.toUTCString():"";try{t=JSON.stringify(n),/^[\{\[]/.test(t)&&(n=t)}catch(e){}n=l.write?l.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=(e=(e=encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var i="";for(var c in o)o[c]&&(i+="; "+c,!0!==o[c]&&(i+="="+o[c]));return document.cookie=e+"="+n+i}e||(t={});for(var a=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,f=0;f<a.length;f++){var p=a[f].split("="),d=p.slice(1).join("=");this.json||'"'!==d.charAt(0)||(d=d.slice(1,-1));try{var u=p[0].replace(s,decodeURIComponent);if(d=l.read?l.read(d,u):l(d,u)||d.replace(s,decodeURIComponent),this.json)try{d=JSON.parse(d)}catch(e){}if(e===u){t=d;break}e||(t[u]=d)}catch(e){}}return t}}return(C.set=C).get=function(e){return C.call(C,e)},C.getJSON=function(){return C.apply({json:!0},[].slice.call(arguments))},C.defaults={},C.remove=function(e,n){C(e,"",g(n,{expires:-1}))},C.withConverter=e,C}(function(){})});
// Promo global object
var P = {};    
(function($){
  $(document).ready(function(){
    var G = {};
    
    if($('#ProductJson-pl-products-temp').length){
      window.pData = JSON.parse(document.getElementById('ProductJson-pl-products-temp').innerHTML);
    }
    console.log(window.pData)
    
    
    var $pop_row = $('#popular-row');
    $pop_row.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    });
    
    // Datepicker Account Registration
    // $( "#dob" ).datepicker();
    
    // Brands Filter
    $(".letters-box a").click(function(e) {
        e.preventDefault();
        var filter = $(this).attr("class");   
 
        if(!$(this).hasClass("active")){
          $(".brands-letter").hide();
            if(filter == "letter-all") {
                $(".brands-letter").show();
                $(this).addClass('active').siblings().removeClass("active");
            } else {
                $(".letter-all").removeClass("active");
                $("."+$(this).attr("class")).show();
                $(this).addClass('active').siblings().removeClass("active");
            }
        }
    });
    
    
    // Hot Deals
    $("#sys_home_dock_hotdeal").on("click",function(){
      var $div = $("<div></div>").addClass("hotdeal-overlay");
      
      $("#sys_home_hotdeal_wrapper").toggleClass("active")
      if($("#sys_home_hotdeal_wrapper").hasClass("active"))
        $div.appendTo($("body"));
      else
        $(".hotdeal-overlay").remove();  
      $("#sys_home_hotdeal_wrapper").stop().slideToggle();
    });
    
    // Moble Menu
    if($(window).width() < 959) {
      $(".nav-toggle").on("click",function(){       
          if ($('html').hasClass('nav-open')) {
              $('html').removeClass('nav-open');
              setTimeout(function () {
                  $('html').removeClass('nav-before-open');
              }, 300);
          } else {
              $('html').addClass('nav-before-open');
              setTimeout(function () {
                  $('html').addClass('nav-open');
              }, 42);
          }
       });
    
      $(".menu > ul > li").unbind("click");
        $(".menu > ul > li").click(function () {
            if ($(window).width() <= 943) {
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $(this).children(".content-level-0").slideUp(150);
                }else {
                    $(".menu > ul > li").removeClass('active');
                    $(this).addClass('active');
                    $(".menu > ul > li .content-level-0").slideUp(150);
                    $(this).children(".content-level-0").slideDown(150);
                }
            }
        });
    }
    
    
    $("#promo-banner-details .dialogify").on("click",function(){
      $(".modal-popup").addClass("_show");
      if($(".modals-overlay").length == 0)
        $("<div></div>").addClass("modals-overlay").appendTo($(".modals-wrapper"));
    });

    $(".modal-popup .action-close").on("click",function(){
      $(".modal-popup").removeClass("_show");
      $(".modals-overlay").remove();
    });



    $(".image-main.cycle-slide-active").elevateZoom({
      gallery:'cycle-slideshow', 
      cursor: 'pointer', 
      galleryActiveClass: 'cycle-pager-active',      
      zoomWindowFadeIn: 300,
      zoomWindowFadeOut: 300,
      lensFadeIn: 300,
      lensFadeOut: 300,
      loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
    });
    
    $("#img-pager>div").click(function(){
      $(".image-main.cycle-slide-active").elevateZoom({
        gallery:'cycle-slideshow', 
        cursor: 'pointer', 
        galleryActiveClass: 'cycle-pager-active',      
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        lensFadeIn: 300,
        lensFadeOut: 300,
        loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
      });    
    })
    
//      var ezAPI = $(".image-main.cycle-slide-active").data('elevateZoom');
//      var mq = window.matchMedia('(min-width: 768px)');
//       mq.addListener((b) => {
//         if (b.matches) {
//             // do something for screens > 768px, for example turn on zoom
//             ezAPI.changeState('enable');
//         } else {
//             // do something for screens < 768px, for example turn off zoom
//             ezAPI.changeState('disable');
//           	$('.zoomContainer').remove();
//         }
//       });

    var $pop_product_carousel = $('#popular-product-carousel')
    $pop_product_carousel.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var _init = function () {
      var $widget = this,
          $colorswatch = $('.color .swatch-option'),
          $element = $('.swatch-option-tooltip'),
          timer,
          type = parseInt($colorswatch.attr('option-type'), 10),
          label = $colorswatch.attr('option-label'),
          thumb = $colorswatch.attr('option-tooltip-thumb'),
          value = $colorswatch.attr('option-tooltip-value'),
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

      $colorswatch.hover(function () {
        if (!$colorswatch.hasClass('disabled')) {
          timer = setTimeout(
            function () {
              var leftOpt = null,
                  leftCorner = 0,
                  left,
                  $window;
              $image.css({
                'background': 'url("' + thumb + '") no-repeat center', //Background case
                'background-size': 'initial'
              });
              $image.show();
              $title.text(label);
              leftOpt = $colorswatch.offset().left;
              left = leftOpt + $colorswatch.width() / 2 - $element.width() / 2;
              $window = $(window);

              // the numbers (5 and 5) is magick constants for offset from left or right page
              if (left < 0) {
                left = 5;
              } else if (left + $element.width() > $window.width()) {
                left = $window.width() - $element.width() - 5;
              }

              // the numbers (6,  3 and 18) is magick constants for offset tooltip
              leftCorner = 0;

              if ($element.width() < $colorswatch.width()) {
                leftCorner = $element.width() / 2 - 3;
              } else {
                leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $colorswatch.width() / 2 - 6;
              }

              $corner.css({
                left: leftCorner
              });
              $element.css({
                left: left,
                top: $colorswatch.offset().top - $element.height() - $corner.height() - 18
              }).show();
            },
            200
          );
        }
      }, function () {
        $element.hide();
        clearTimeout(timer);
      });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });

      $colorswatch.on('tap', function (event) {
        event.stopPropagation();
      });
    }
    
    if($('body').hasClass('template-product')){
      // color / variant switching
      // window.pData -> global object for product data
      window.pVars = window.pData.variants;
      var $addToCartBtn = $('#AddToCart-pl-products-temp'),
          $productFormID = $('#ProductID-pl-products-temp'),
          varslength = window.pVars.length;   

      function getStockText(varid){
        var invCount = window.viq[varid],
            stockText = (invCount > 1) ? ' stocks left' : ' stock left';
        if(invCount == 0){
          stockText = "Out of stock";
        } else {
          stockText = 'Only ' + invCount + stockText;
        }
        $('#variant-inventory').text(stockText);
        console.log(invCount)
      }

      function getVarID(opts){
        if(opts.prodtype == "Shoes"){
          // logic for shoes
          var optcolor = opts.color,
              optsize = opts.size;
          for (var a = 0; a < varslength; a++){
            var currVar = window.pVars[a],
                currColor = currVar.option1,
                currSize = currVar.option2
            if(currColor == optcolor && currSize == optsize){
              $productFormID.val(currVar.id);
              getStockText(currVar.id);
            }
          }
        }
      }

      function updateVarPrice(opts){
        var optid = opts.id;
        for (var a = 0; a < varslength; a++){
          var moneySymbol = "₱";
          var currVar = window.pVars[a],
              salePrice = currVar.price,
              origPrice = currVar.compare_at_price,
              $regPriceSpan = $('#ComparePrice-pl-products-temp'),
              $salePriceSpan = $('#ProductPrice-pl-products-temp'),
              currPrice = currVar.price/100,
              currPrice = currPrice.toFixed(2),
              currPrice = moneySymbol + currPrice.toLocaleString(),
              regPrice = currVar.compare_at_price/100,
              regPrice = regPrice.toFixed(2),
              regPrice = moneySymbol + regPrice.toLocaleString();
          if(currVar.id == optid){
            if(salePrice < origPrice){
//               $regPriceSpan.text(regPrice).parent().show();
              $salePriceSpan.text(currPrice);
            } else {
              $regPriceSpan.parent().hide();
              $salePriceSpan.text(currPrice);
            }
          }
        }
      }



      $('.color .swatch-option').click(function(e) {
        var $this = $(this);
        if (!$this.hasClass('disabled')){
          var $idx = $this.data('swatch-index'),
              $label = $this.attr('option-label');
          $this.addClass('selected').siblings().removeClass('selected');
          // change showcased image group according to color selected
          var $imgGroupMain = $('.img-group:eq('+$idx+').container-zoom').show(),
              $imgGroupPager = $('.img-group.container-pager:eq('+$idx+')').show();
          
          

          $imgGroupMain.children().first().trigger('click');
          $imgGroupPager.children().first().trigger('click');
          $imgGroupMain.siblings('.container-zoom').hide();
          $imgGroupPager.siblings('.container-pager').hide();
          // show the selected color on label
          $this.parent().prev().find('.swatch-attribute-selected-option').text($label);

          if(window.pData.type == "Shoes"){

            // disable all sizes first
            $('.size .swatch-option, .width .swatch-option').addClass('disabled');
            $('.size .swatch-option input, .width .swatch-option input').attr('disabled',true);
            var colorSizeOptions = [];
            var activeSwatch = $('.size .swatch-option.selected'),
                activeSize = activeSwatch.attr('option-label'),
                activeWidthSwatch = $('.width .swatch-option.selected'),
                activeWidth = activeWidthSwatch.attr('option-label');
            
            activeSwatch.removeClass('selected');
            activeWidthSwatch.removeClass('selected');
            $('.size .swatch-attribute-selected-option').text('');
            $productFormID.val('');
            $addToCartBtn.addClass('disabled').attr('disabled',true);
            for (var a = 0; a < varslength; a++){
              var currVar = window.pVars[a],
                  currColor = currVar.option1,
                  currSize = currVar.option2,
                  currWidth = currVar.option3,
                  sVCount = 0;
              
              if(currColor == $label){
                
                colorSizeOptions.push(currSize);
                var $size = $('.size .swatch-option[option-label="'+currSize+'"]');
                var $width = $('.width .swatch-option[option-label="'+currWidth+'"]');
                if(currVar.available) {
                  sVCount++;
                  $size.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                  $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                  
                  var swWidth = $('.footwear_width').find('.swatch-option'),
                      loopcounter = 0,
                      disCounter = 0

                  $.each(swWidth, function(i,e){
                    var data = $(this)
                    
                    loopcounter++

                    if(data.hasClass('disabled')){
                      disCounter++
                    }
                  })
                  console.log(disCounter)

                  if(disCounter > 0 || loopcounter < 2){
                    swWidth.trigger('click')
                  }                  
                  
//                   if(--sVCount <= 0){
//                    	$size.trigger('click')
//                   }
                  
//                   $.each($width, function(){
//                     var wCount = 0,
//                         $thisW = $(this)

//                     if($thisW.hasClass('available')){
//                      	wCount++ 
//                     }
                    
//                       })
                  console.log(currWidth)
                  //console.log(currVar.id[0]);
                  var opts = {
                    id: currVar.id
                  }

                  updateVarPrice(opts);                   
                  
                  if(activeSize == currSize){
                    getStockText(currVar.id);
                    activeSwatch.addClass('selected');
                    var opts = {
                      id: currVar.id
                    }
                    
                    updateVarPrice(opts);   
                    $productFormID.val(currVar.id);
                    $addToCartBtn.addClass('enabled').attr('enabled',true);                    
                  }
                } else {
                  if(activeSize == currSize){
                    $('.size .swatch-attribute-selected-option').text('');
                    $productFormID.val('');
                    $addToCartBtn.addClass('disabled').attr('disabled',true);
                  }
                  $size.addClass('disabled').removeClass('selected')
                  .removeClass('available').children('input')
                  .attr('disabled',true);
                }
              }
            }

            // check if a size is already selected
            var selectedVarID = $('#ProductID-pl-products-temp').val();
            if ($('.size .swatch-option.selected').length && selectedVarID != ""){
              $addToCartBtn.removeClass('disabled').attr('disabled',false);
              var opts = {
                id: selectedVarID
              }
              updateVarPrice(opts);
              
            }
          } else {
            
            for (var a = 0; a < varslength; a++){
              var currVar = window.pVars[a],
                  currColor = currVar.option1;
              if(currColor == $label){
                $productFormID.val(currVar.id);
                $addToCartBtn.removeClass('disabled').attr('disabled',false);
                if(window.viq[currVar.id] != undefined){
                  getStockText(currVar.id);
                }
              }
            }
            
          }

        } else {
          return false;
        }
      });


      $('.size .swatch-option, .footwear_width .swatch-option').click(function(e) {
        var $this = $(this);
        if (!$this.hasClass('disabled')){
          var $idx = $this.index();
          var $label = $this.attr('option-label')
          $(this).addClass('selected').siblings().removeClass('selected');    
          $this.parent().prev().find('.swatch-attribute-selected-option').text($label);
          var $swatchAttribute = $this.closest('.swatch-attribute');


          if($swatchAttribute.hasClass('size')){
            var opts = {
              prodtype: "Shoes",
              color: $('.color .swatch-option.selected').attr('option-label'),
              size: $label
            }
            getVarID(opts);
            opts.id = $productFormID.val();
            
//             console.log($productFormID.val() + " Sizes on click test")
            
            updateVarPrice(opts);
            $addToCartBtn.removeClass('disabled').attr('disabled',false);
            for(v in window.viq){
              if(window.viq[opts.id] != undefined){
                getStockText(opts.id);
              }
            }
          } else {
            if($('.color .swatch-option.selected').length && $('.size .swatch-option.selected').length){
              $addToCartBtn.removeClass('disabled').attr('disabled',false);
            }
          }

        }
      });
    }
    
    /*
    if($('body').hasClass('template-product')){
      var $defaultVariant = $('select.product-form__variants option[selected]').text().split(' / ');
      var arrayLength = $defaultVariant.length;
      var $defaultfirstoption = $defaultVariant[0];
      for (var i = 0; i < arrayLength; i++) {
        $('.swatch-attribute:eq('+i+') .swatch-option[option-label="'+$defaultVariant[i]+'"]').trigger('click');
      }
      var G = {};
      G.var2disable = [];
      var $disabledVariants = $('select.product-form__variants option[disabled]');
      var $varToDisable = $.grep($disabledVariants, function(n, i) {
        var var2disable = $(n).text().split(' / ');
        if (var2disable[0] == $defaultfirstoption){
          G.var2disable.push(var2disable);
        }
      });
    }
    */
    
    
    // disabling this
    // as we are now using
    // hidden input
    /*
    $(function() {
      $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
        $('#ProductSelect-pl-products-temp').trigger('change');
      });
    });
    */
    
    var swatchtooltip = function (item){ 
      var $element = $('.swatch-option-tooltip'),
          timer,
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

//       item.hover(function () {
//         var $this = $(this),
//             label = $this.attr('option-label'),
//             thumb = $this.attr('option-tooltip-thumb'),
//             value = $this.attr('option-tooltip-value'),
//             type = parseInt($this.attr('option-type'), 10);
//         if (!$this.hasClass('disabled')) {
//           timer = setTimeout(
//             function () {
//               var leftOpt = null,
//                   leftCorner = 0,
//                   left,
//                   $window;
//               if (type === 2) {
//                 // Image
//                 $image.css({
//                   'background': 'url("' + thumb + '") no-repeat center', //Background case
//                   'background-size': 'initial'
//                 });
//                 $image.show();
//               } else if (type === 1) {
//                 // Color
//                 $image.css({
//                   background: value
//                 });
//                 $image.show();
//               } else if (type === 0 || type === 3) {
//                 // Default
//                 $image.hide();
//               }
//               $title.text(label);
//               leftOpt = $this.offset().left;
//               left = leftOpt + $this.width() / 2 - $element.width() / 2;
//               $window = $(window);
//               // the numbers (5 and 5) is magick constants for offset from left or right page
//               if (left < 0) {
//                 left = 5;
//               } else if (left + $element.width() > $window.width()) {
//                 left = $window.width() - $element.width() - 5;
//               }

//               // the numbers (6,  3 and 18) is magick constants for offset tooltip
//               leftCorner = 0;

//               if ($element.width() < $this.width()) {
//                 leftCorner = $element.width() / 2 - 3;
//               } else {
//                 leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $this.width() / 2 - 6;
//               }

//               $corner.css({
//                 left: leftCorner
//               });
//               $element.css({
//                 left: left,
//                 top: $this.offset().top - $element.height() - $corner.height() - 18
//               }).show();
//             },
//             200
//           );
//         }
//       }, function () {
//         $element.hide();
//         clearTimeout(timer);
//       });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });
    }
    
    $('#bc-sf-filter-products').on('click','.swatch-option.image',function(e){
      var $this = $(this),
          idx = $this.index(),
          $parent = $this.closest('.product-item'),
          $imgContainer = $parent.find('.img-container');
      $imgContainer.children('img').eq(idx).show().siblings().hide();
      
      		console.log($this + " " + idx + " " + $parent + " " + $imgContainer )
    });
    
    
    
    var filswatchtooltip = function (item){ 
      var $element = $('.swatch-option-tooltip'),
          timer,
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }
      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');
      item.hover(function () {
        var $this = $(this),
            label = $this.parent().data('title'),
            type = 2;

        var texts = $this.css('background-image');
            texts.toString();
            texts = texts.replace('url("','');
        var thumb = texts.replace('")','');
        var value = thumb;
        if (!$this.hasClass('disabled')) {
          timer = setTimeout(
            function () {
              var leftOpt = null,
                  leftCorner = 0,
                  left,
                  $window;

              if (type === 2) {
                $image.css({
                  'background': 'url("' + thumb + '") no-repeat center', //Background case
                  'background-size': 'initial'
                });
                $image.show();
              }

              $title.text(label);

              leftOpt = $this.offset().left;
              left = leftOpt + $this.width() / 2 - $element.width() / 2;
              $window = $(window);

              // the numbers (5 and 5) is magick constants for offset from left or right page
              if (left < 0) {
                left = 5;
              } else if (left + $element.width() > $window.width()) {
                left = $window.width() - $element.width() - 5;
              }
              // the numbers (6,  3 and 18) is magick constants for offset tooltip
              leftCorner = 0;
              if ($element.width() < $this.width()) {
                leftCorner = $element.width() / 2 - 3;
              } else {
                leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $this.width() / 2 - 6;
              }
              $corner.css({ left: leftCorner });
              $element.css({
                left: left,
                top: $this.offset().top - $element.height() - $corner.height() - 18
              }).show();
            },
            200
          );
        }
      }, function () {
        $element.hide();
        clearTimeout(timer);
      });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });
    }
    
    var refreshCollection = function(arg){
      if (arg.length == 0) {
        $('.main .category-view').show();
        if (!($('body').hasClass('vendor') || $('body').hasClass('sale'))) {
          $('#pl-product-grid').hide();
        } else {
          var defaultSwatch = $('#default-swatch').text().toString();
          setTimeout(function(){
            jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
              var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
//               var swatchbg = 'background-image: url('+newswatch+')';
              $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
              swatchtooltip($(e));
            });
//             filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
          },1000);
        }
        setTimeout(function(){
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      } else {
        $('#pl-product-grid').show();
        $('.main .category-view').hide()
        var defaultSwatch = $('#default-swatch').text().toString();
        setTimeout(function(){
          jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
            var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
//             var swatchbg = 'background-image: url('+newswatch+')';
            $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
            swatchtooltip($(e));
          });
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      }
    }

    if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
      refreshCollection(window.location.search);
      $(document).on("click",function(e,d){
        var warg = window.location.search;
        refreshCollection(warg);
      });
      $(document).on('change','.collection-sort__input',function(){
        $(document).trigger('click');
      });
//       filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
      $(document).trigger('click');
    }
    
    if ($('body').hasClass('template-product')) {
      swatchtooltip($('.swatch-option.color'));
      // compare prices show
      window.prodvardata = JSON.parse(document.getElementById('ProductJson-pl-products-temp').innerHTML);
//       $('#ProductSelect-pl-products-temp').on('change',function(e){
//         var $this = $(this).find('option:selected');
//         var $val = $this.val();
//         var $list = window.prodvardata.variants;
//         for (var i=0; i<$list.length; i++) {
//           if ($val == $list[i].id){
//             var $newvar = $list[i];
//             var $newprice = $newvar.price / 100;
//             var $compprice = $newvar.compare_at_price / 100;
//             if($newprice < $compprice) {
//               $('.old-price').show();
//               $('#compprice').addClass('active').show();
//               $('#compprice-val').text($compprice.toFixed(2));
//             }else {
//               $('.old-price').hide();
//               $('#compprice-val').text($compprice.toFixed(2));
//             }
//           }
//         }
//       });
      
      // product detail and shipping calculator tab switches
      $('.data a.switch').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $($this.attr('href'));
        $this.parent().addClass('active').siblings('.data.item.title').removeClass('active');
        if (!$target.hasClass('shown')) {
          $target.show().addClass('shown').siblings('.data.item.content').hide().removeClass('shown');
        }
      });
      
      
      // shipping calculator logic
      window.currcartitems = window.cartitems;    
      $('.action.ship-calc').click(function(e){
        cartitems = 0;
        var $zipInput = $('#pcte');
        var $ziVal = $zipInput.val();
        var isnum = /^\d+$/.test($ziVal);
        var ziplength = $ziVal.length;
        $('#custom-message-error').hide();
        if (isnum && ziplength == 4) {
          var $zip = parseInt($ziVal);
          // check if provincial or metro manila
          window.currAddress = '';
          if ($zip > 1820) {
            for (var i=1;i<79;i++) {
              $currprov = provzip[i].prov;
              $.each(provzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currprov;
                  i = 78;
                }
              });
            }
          } else {
            for (var i=1;i<18;i++) {
              $currcity = mmzip[i].city;
              $.each(mmzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currcity;
                  i = 18;
                }
              });
            }
          }
          cartitems = window.currcartitems + parseInt($('#Quantity').val());
          if (window.currAddress.length) {
            console.log('cartitems: ' + cartitems);
            if ($zip < 1821) {
              if ( cartitems == 1 ){
                $shipcost = 'Php 190.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 190.00';
              } else {
                $shipcost = 'Php 600.00';
              }
              $dateestimate = '3-5 days';
            } else {
              if ( cartitems == 1 ){
                $shipcost = 'Php 270.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 270.00';
              } else {
                $shipcost = 'Php 800.00';
              }
              $dateestimate = '5-7 days';
            }
            $('#shipped-info').show().next().hide();
            $('#curr-address').text(window.currAddress);
            $('#date-estimate').text($dateestimate);
            $('#pl-shipping-amount').text($shipcost);
            $('#sip-tab-info').slideDown();
          } else {
            $('#custom-message-error').show();
            $('#sip-tab-info').hide();
          }
        } else {
          $('#custom-message-error').show();
          $('#sip-tab-info').hide();
        }
      });
      
      // change estimate place
      $('#shipped-info a.edit').click(function(e){
        e.preventDefault();
        $('#shipped-info').hide().next().show();
      });
      
      
      // contextualizing for easy use.
      // this function is recently added
      // to address the issue of wrong sizes
      // being added to cart
      var rawProductData = window.prodvardata,
          rpd = rawProductData,
          orgData = {
            colors: [],
            sizes: []
          };
      var variants = rpd.variants,
          l = variants.length,
          colorArr = orgData.colors,
          sizeArr = orgData.sizes
      if (rpd.type == "Shoes") {
        for (var i = 0; i < l; i++) { 
          var currVar = variants[i],
              varColor = currVar.option1,
              varSize = currVar.option2;
          if (currVar.available) {
             if (colorArr.indexOf(varColor) < 0) {
               colorArr.push(varColor);
               var obj = [{size: varSize,id: currVar.id}];
               sizeArr.push(obj);
             } else {
               var colorPos = colorArr.indexOf(varColor);
               sizeArr[colorPos].push({size: varSize,id: currVar.id});
             }
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-pl-products-temp');
        $ctabtn.attr('disabled',true);
        // use of data on line 245
      }else {
        for (var i = 0; i < l; i++) {
          var currVar = variants[i],
              varColor = currVar.option1;
          if (currVar.available && colorArr.indexOf(varColor) < 0) {
            var obj = [{color: varSize,id: currVar.id}];
            	colorArr.push(obj);
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-pl-products-temp');
        $ctabtn.attr('disabled',true);
      }
      $(window).load(function(){
        $('.color .swatch-option.available').first().trigger('click');
        $addToCartBtn.text('Add To Bag');
      });
      
    }
    
    // newsletter signup submit
    $('#newsletter-validate-detail').on('submit',function(e){
      e.preventDefault();
      if ($('.subscribe .confirmation input').is(':checked')) {
        var $this = $('#newsletter-email-val');
        var $val = $this.val();
        $('#mce-EMAIL').val($val);
        $('#mc-embedded-subscribe-form').trigger('submit');
      } else {
        alert('Please tick Privacy Policy checkbox.')
      }
    });
    
    // account creation privacy policy
    $('#authenticationPopup input[type="submit"]').click(function(e){
      e.preventDefault();
      if ($('.fieldset .confirmation input').is(':checked')) {
        $('#form-validate').submit();
      } else {
        alert('Please tick Privacy Policy checkbox.');
      }
    });
    
    // RELATED PRODUCTS
    $.fn.pick = function(how_many) {
      var how_many = how_many || 4;
      // Picking random numbers without repeating. 
      var index_array = [];
      var original_obj_size = this.size();
      for (var i=0; i<original_obj_size; i++) {
        index_array.push(i);
      }
      //+ Jonas Raoni Soares Silva
      //@ http://jsfromhell.com/array/shuffle [rev. #1]
      var shuffle = function(v) {
        for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
        return v;
      };
      function theshuffle(array) {
        var cI = array.length, tV, rI;
        while (0 !== cI) {
          rI = Math.floor(Math.random() * cI);
          cI -= 1;
          tV = array[cI];
          array[cI] = array[rI];
          array[rI] = tV;
        }

        return array;
      }
      var new_index_array = theshuffle(index_array)
      new_index_array.slice(0,how_many);
      

      // Ditching unpicked elements and removing those from the returned set.
      return this.each(function(i) {
         if ($.inArray(i,new_index_array) === -1) {
            $(this).remove();
         }
      }).filter(function() {
        if (this.parentNode === null) {
          return false;
        }
        else {
          return true;
        }
      });

    };
    
    jQuery.fn.yesshuffle = function () {
      var j;
      for (var i = 0; i < this.length; i++) {
        j = Math.floor(Math.random() * this.length);
        $(this[i]).before($(this[j]));
      }
      return this;
    };
    
    if($('.products-related .product-item') !== undefined) {
      $('.products-related .product-item').pick(4);
      $('.products-related .product-item').yesshuffle();
    }
    
//     console.log($('.products-related .product-item'))
    window.prodlistbuilt = false;
    
    // 
    $(window).on("load",function(){  
      var elem = document.querySelector('.product-items');
      if(elem !== null){
        if($('#bc-sf-filter-bottom-pagination').length){
          /*var infScroll = new InfiniteScroll( elem, {
            // options
            path: '.pl-next',
            append: '.product-item',
            history: false
          });*/
          //var $con = $('#bc-sf-filter-products.product-items');
          //$con.infiniteScroll({
          // path: '.pl-next',
          // append: '.product-item',
          // history: false
          //});
        }
        $("#bc-sf-filter-tree").addClass("filter-options");
      
        $(".filter-title").on("click",function(){
            $("body").toggleClass("filter-active");
          $(".block.filter").toggleClass("active");
        });
      }
      $(document).trigger('click');
      
      if($('body').hasClass('template-cart')) {
        var $promototaltext = $('.saso-cart-total').text();
        var $carttotal = $promototaltext.replace(' PHP','');
        var srp = parseFloat($carttotal.replace('₱','').replace(',',''));
        var vatablesale = parseFloat((srp/1.12).toFixed(2));
        var tax = parseFloat((vatablesale*0.12).toFixed(2));
        var sstotal = '₱'+ vatablesale.toLocaleString('en');
        var taxtotal = '₱'+ tax.toLocaleString('en');
        if ($promototaltext.length > 1){
          $('#saso-subtotal').text(sstotal);
          $('#tax-total').text(taxtotal);
          $('#est-total').text($carttotal);
          //temp 
          var $sslsa = $('.saso-summary-line-spend-amount'),
            sstext = $sslsa.html();
//           sstext = sstext.replace('undefined','Payday Yay!');
//           $sslsa.html(sstext);
        }
      }
      
    });
    
    // store finder page
//     $('.locator_arrow').click(function(e){
//       $(this).toggleClass('arrow_active').closest('.today_schedule').next().slideToggle();
//     });
    
    // account dashboard toggle for mobile
    $('.title.block-collapsible-nav-title').click(function(){
      var $this = $(this);
      $this.toggleClass('active').next().toggleClass('active');
    });
    
    $('.address-new-toggle').click(function(){
//       $('#AddressNewForm').slideDown(300)
    });
    
    
    
//     if ($('body').hasClass('template-cart')){
//       // declare variables
//       window.xcartItems = [];
//       var currentPromoName = 'Buy 2 Get 1',
//           promoAppliesToCart = false,
//           lowestPrice = 0,
//           lowestPricedItems = [],
//           lowestPricedItemsCount = 0,

//           // regular items
//           preReqCount = 0,
//           regularItems = [],
//           regularPricesArr = [],

//           // sale items
//           saleItems = [],
//           salePricesArr = [],

//           // entitled items
//           entitledItems = [],
//           entitledItemCount = 0,
//           entitledPricesArr = [],

//           // cart price data
//           discountPrice = 0,
//           baseSubtotal = 0,
//           entitledCount = 0,
//           totalCartQuantity = 0,
//           discountedSubtotal = 0,
//           itemsToDiscount = 0;
        
//      // sorting function: arrange items according to property
//      function dynamicSort(property) {
//        var sortOrder = 1;
//        if(property[0] === "-") {
//          sortOrder = -1;
//          property = property.substr(1);
//        }
//        return function (a,b) {
//          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
//          return result * sortOrder;
//        }
//      }

//       // loop through cart line items 
//       // and push them into window.xcartItems 
//       $('.cart-row .item').each(function(i,e){
//         $el = $(e);
//         item = {
//           product_id: $el.data('productid'),
//           variant_id: $el.data('variantid'),
//           tags: $el.data('tags').toLowerCase(),
//           name: $el.data('title'),
//           price: $el.data('price'),
//           quantity: parseInt($el.data('qty')),
//           row: $el.data('row')
//         }
//         isRegularItem = item.tags.indexOf("regular");
//         if(isRegularItem > -1){
//           regularItems.push(item);
//           preReqCount += item.quantity;
//         } else {
//           saleItems.push(item);
//         }
//         totalCartQuantity += item.quantity;
//         window.xcartItems.push(item);
//       });

//       // sort from lowest to highest price
//       regularItems.sort(dynamicSort("price"));
//       saleItems.sort(dynamicSort("price"));
//       window.xcartItems.sort(dynamicSort("price"));
//       lowestPrice = window.xcartItems[0].price;

//       // check if there are enough prerequisite items in cart
//       var discountGroups = Math.trunc(totalCartQuantity/3); // a discount group needs 2 prerequisites and 1 entitled item
//       var discountableItems = Math.trunc(preReqCount/2);
//       var preReqModulo = preReqCount%2;

//       // push regular prices into array for comparison
//       for (var i = 0; i < regularItems.length; i++) {
//         for (var j = 0; j < regularItems[i].quantity; j++){
//           regularPricesArr.push(regularItems[i].price);
//         }
//       }

//       // push sale prices into array for comparison
//       for (var i = 0; i < saleItems.length; i++) {
//         for (var j = 0; j < saleItems[i].quantity; j++){
//           salePricesArr.push(saleItems[i].price);
//         }
//       }



//       // there are more than 2 Regular Items in the cart
//       if (preReqCount > 2) {
//         $('#checkout-button').attr('href','/checkout?discount=FP7B2G1');
//         $('#checkout-form').attr('action','/checkout?discount=FP7B2G1');
//         var markup = '<tr class="totals"><th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//                 '<span class="saso-summary-line-buyxgety">Buy 2 Get 1:<br>Discount will apply on checkout.</span>'+
//           '</div></th></tr>';
//         $(markup).insertBefore($('.totals-tax'));
//       } else {
//         if (discountableItems > 0) {
//           // loop through cart items to check for entitled items
//           for (var i = 0; i < window.xcartItems.length; i++) {
//             var XItem = window.xcartItems[i];
//             var XPrice = XItem.price;
//             var XTags = XItem.tags
//             // 
//             if(i == preReqCount) break;
//             if(entitledItems.length != discountableItems){
//               if(XPrice <= regularPricesArr[entitledItems.length]){
//                 if (regularItems[entitledItems.length] !== XItem) {
//                   entitledItems.push(XItem);
//                 }
//               }
//             } else {
//               break;
//             }
//           }
//           // if there are 
//           if(entitledItems.length){
//             var licount = 0,
//                 discountPrice = 0;
//                 discountItemsArr = 0;
//             for(; licount < discountGroups; licount++){
//               var liQuantity = entitledItems[licount].quantity;
//               for(var innerCounter = 0; innerCounter < liQuantity; innerCounter++){
//                 if (discountItemsArr == discountGroups) break;
//                 var markup = '<tr class="totals">'+
//                     '<th colspan="1" style="" class="mark" scope="row">'+
//                     '<div class="saso-summary">'+
//                     '<span class="saso-summary-line-buyxgety">{currentPromoName}:<br>{itemTitle}</span>'+
//                     '</div>'+
//                     '</th>'+
//                     '<td class="amount">'+
//                     '<span class="price">'+
//                     '<span class="saso-price">- ₱{itemPrice}</span>'+
//                     '</span>'+
//                     '</td>'+
//                     '</tr>';
//                 pp = parseFloat((parseInt(entitledItems[licount].price)/100).toFixed(2));
//                 pq = pp.toFixed(2).toLocaleString('en');
//                 markup = markup.replace(/{currentPromoName}/g, currentPromoName);
//                 markup = markup.replace(/{itemTitle}/g, entitledItems[licount].name);
//                 markup = markup.replace(/{itemPrice}/g, pq);
//                 $(markup).insertAfter($('.totals.sub.incl'));
//                 ePrice = entitledItems[licount].price;
//                 discountPrice += ePrice;
//                 discountItemsArr++;
//               }
//             }
//             discountPrice /= 100;
//             var sstotaltext = $('#saso-total').prev('.saso-cart-original-total').text(),
//                 srp = parseFloat(sstotaltext.replace('₱','').replace(',','')),
//                 esttotal = (srp - discountPrice).toFixed(2),
//                 totalDiscount = '₱'+ (discountPrice).toFixed(2),
//                 vatablesale = parseFloat((esttotal/1.12).toFixed(2)),
//                 tax = parseFloat((vatablesale*0.12).toFixed(2)),
//                 sstotal = '₱'+ vatablesale.toLocaleString('en'),
//                 taxtotal = '₱'+ tax.toLocaleString('en');

//               $('#saso-subtotal').text(sstotal);
//               $('#saso-total,#est-total').text('₱' + esttotal.toLocaleString('en'));
//               $('#tax-total').text(taxtotal);
//               $('.saso-cart-original-total').css('text-decoration','line-through');

//               var discountTotes = '<tr class="totals">'+
//                   '<th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//                   '<span class="saso-summary-line-buyxgety">Total Discount:</span>'+
//                   '</div></th>'+
//                   '<td class="amount">'+
//                   '<span class="price">'+
//                   '<span class="saso-price">- {totalDiscount}</span>'+
//                   '</span>'+
//                   '</td>'+
//                   '</tr>';
//               discountTotes = discountTotes.replace(/{totalDiscount}/g, totalDiscount);
//               $(discountTotes).insertBefore($('.totals-tax'));
//             $('#checkout-button').attr('href','/checkout?discount=FP7B2G1');
//             $('#checkout-form').attr('action','/checkout?discount=FP7B2G1');
//           } else {
//             $('#checkout-button').attr('href','/checkout?discount=REGULARORDER');
//             $('#checkout-form').attr('action','/checkout?discount=REGULARORDER');
//           }
//         }
//       }
//     }
    
    
    /* bogo promo test */
    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
      });
      return vars;
    }
    // sorting function: arrange items according to property
    function dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    }
    
    if (getUrlVars()['xmasbogo'] == 'test'){
      var in30Minutes = 1/48;
      Cookies.set('bogotest', 'test', { expires: in30Minutes });
    }
//     if(Cookies.get('bogotest') == 'test'){
//       if ($('body').hasClass('template-cart')){
//         // declare variables
//         window.xcartItems = [];
//         P = {
//           currentPromoName: 'Buy 1 Get 1 @ 50%',
//           promoAppliesToCart: false,
//           lowestPrice: 0,
//           lowestPricedItems: [],
//           lowestPricedItemsCount: 0,
//           allPricesArr: [],
//           // regular items
//           preReqCount: 0,
//           regularItems: [],
//           regularPricesArr: [],
//           // sale items
//           saleItems: [],
//           salePricesArr: [],
//           // entitled items
//           entitledItems: [],
//           entitledItemCount: 0,
//           entitledPricesArr: [],
//           // cart price data
//           discountPrice: 0,
//           baseSubtotal: 0,
//           entitledCount: 0,
//           totalCartQuantity: 0,
//           discountedSubtotal: 0,
//           itemsToDiscount: 0
//         };

//         // loop through cart line items 
//         // and push them into window.xcartItems 
//         $('.cart-row .item').each(function(i,e){
//           var $el = $(e);
//           var item = {
//             product_id: $el.data('productid'),
//             variant_id: $el.data('variantid'),
//             tags: $el.data('tags').toLowerCase(),
//             name: $el.data('title'),
//             price: $el.data('price'),
//             quantity: parseInt($el.data('qty')),
//             row: $el.data('row')
//           },
//           isRegularItem = item.tags.indexOf("regular");
//           if(isRegularItem > -1){
//             P.regularItems.push(item);
//             P.preReqCount += item.quantity;
//           } else {
//             P.saleItems.push(item);
//           }
//           P.totalCartQuantity += item.quantity;
//           window.xcartItems.push(item);
//         });
        
        
//         // sort from lowest to highest price
//         P.regularItems.sort(dynamicSort("price"));
//         P.saleItems.sort(dynamicSort("price"));
//         window.xcartItems.sort(dynamicSort("price"));
//         P.lowestPrice = window.xcartItems[0].price;

//         // push regular prices into array for comparison
//         for (var i = 0; i < P.regularItems.length; i++) {
//           for (var j = 0; j < P.regularItems[i].quantity; j++){
//             P.regularPricesArr.push(P.regularItems[i].price);
//           }
//         }

//         // push sale prices into array for comparison
//         for (var i = 0; i < P.saleItems.length; i++) {
//           for (var j = 0; j < P.saleItems[i].quantity; j++){
//             P.salePricesArr.push(P.saleItems[i].price);
//           }
//         }
        
//         // push sale prices into array for comparison
//         for (var i = 0; i < window.xcartItems.length; i++) {
//           for (var j = 0; j < window.xcartItems[i].quantity; j++){
//             P.allPricesArr.push(window.xcartItems[i].price);
//           }
//         }
        
//         P.regularPricesArr.reverse();
//         P.salePricesArr.reverse();
//         P.allPricesArr.reverse();
        
        
//         var aPL = P.allPricesArr.length - 1;
//         var markup = '<tr class="totals"><th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//             '<span class="saso-summary-line-buyxgety" style="color:#e24057">'+ P.currentPromoName +':<br>Discount will apply on checkout.</span>'+
//           '</div></th></tr>';
        
//         var $checkoutBtn = $('#checkout-button');
//         var $checkoutForm = $('#checkout-form');
//         if(P.preReqCount >= 1 && P.regularPricesArr[0] >= P.allPricesArr[aPL] && P.totalCartQuantity < 4 && P.totalCartQuantity > 1){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1A');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1A');
//           $(markup).insertBefore($('.totals-tax'));
//         } else if (P.preReqCount >= 3 && P.regularPricesArr[2] >= P.allPricesArr[5] && P.totalCartQuantity >= 6){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1C');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1C');
//           $(markup).insertBefore($('.totals-tax'));
//         } else if (P.preReqCount >= 2 && P.regularPricesArr[1] >= P.allPricesArr[2] && P.totalCartQuantity >= 4){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1B');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1B');
//           $(markup).insertBefore($('.totals-tax'));
//         } else {
//           $('#checkout-button').attr('href','/checkout?discount=REGULARORDER');
//           $('#checkout-form').attr('action','/checkout?discount=REGULARORDER');
//         }
        
        
      
//       }
//     }
    
    
    
    $('#bc-sf-filter-products').on('hover','.swatch-option.image',function(e){
      console.log('gwapo si MJ!');
    });
    
    
    
    
    

  });
})(jQuery);